import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const FormFieldContainer = styled.div<{ isFinishStep?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  row-gap: 8px;
  column-gap: 16px;
  .ant-select-show-search {
    width: 288px;
  }
  ${({ isFinishStep }) => (isFinishStep ? 'flex-direction: column;' : '')};
  @media ${DEVICES.sm} {
    display: flex;
    flex-direction: column;
    gap: 6px;
    .ant-select-show-search {
      width: 100%;
    }
  }
`;

export const MainWrapper = styled.div`
  width: fit-content;
`;
